import { Modal, ModalContent } from 'pobble-components/dist/modal'
import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import ButtonElement from 'pobble-components/dist/button-element'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExpand } from '@fortawesome/pro-regular-svg-icons/faExpand'
import { faPrint } from '@fortawesome/pro-regular-svg-icons/faPrint'
import { faFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt'
import { faQrcode } from '@fortawesome/pro-regular-svg-icons/faQrcode'
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope'
import { faUsersClass } from '@fortawesome/pro-regular-svg-icons/faUsersClass'
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faPencil } from '@fortawesome/pro-regular-svg-icons/faPencil'
import { apiClient } from 'pobble-components/dist/api'
import { toast } from 'pobble-components/dist/toast'
import { useHistory } from 'react-router-dom'
import { usePresentMode } from '../pages/direct-present/present-mode'
import Tooltip from 'pobble-components/dist/tooltip'
import PrintModal from '../print-modal/print-modal'
import ShareLessonModal from '../share-lesson-modal/share-lesson-modal.container'
import { useMe } from 'pobble-components/dist/pobble-user'
import { QRCodeModal } from './qrcode'
import SendToPupilsModal from '../pages/lesson/send-to-pupils-modal/send-to-pupils-modal'
import classNames from 'classnames'
import gclassroom from './gclassroom.png'
import posthog from 'posthog-js'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import { UpsellModal } from '../pages/prompt/upsell'
import { useWritingPack, WritingPackModal } from './writing-pack'
import { SubsCrown } from 'pobble-components/dist/subscriptions'

function objectToQueryParam(obj) {
  return Object.keys(obj)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    .join('&')
}

const EditLesson = injectSheet({
  button: {
    fontWeight: 'bold',
    color: 'var(--dark-blue)',
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    padding: '0 4px',
    '& *': {
      pointerEvents: 'none'
    },
    '& svg': {
      fontSize: '12px'
    },
    '&:hover': {
      color: 'var(--dark-blue-)'
    },
    '&:focus': {
      outline: '1px solid var(--gray---)',
      outlineOffset: '4px',
      borderRadius: '4px'
    }
  }
})(({ classes, presentation, onClick }) => {
  const history = useHistory()
  const [pending, setPending] = useState(false)
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)
  const { hasAccessToTL } = useSubscriptionDetails()

  return (
    <>
      <ButtonElement
        disabled={pending}
        onClick={() => {
          onClick && onClick()
          if (!hasAccessToTL) {
            return setUpsellModalOpen(true)
          }
          setPending(true)
          apiClient
            .post(
              `/v3/presentations/${presentation.id}/create_presentation_copy`
            )
            .then(res => {
              history.push(`/lesson/${res.data.presentation.id}`, {
                fromPrompt: true
              })
            })
        }}
        className={classNames(classes.button, 'metrics__edit-button')}>
        {!pending && (
          <>
            <FontAwesomeIcon icon={faPencil} />Edit lesson before sharing
          </>
        )}
        {pending && 'Creating your copy...'}
      </ButtonElement>
      <UpsellModal
        id="edit-lesson"
        isOpen={upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </>
  )
})

const LessonLink = injectSheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  label: {
    fontWeight: 'bold',
    color: 'var(--gray)'
  },
  link: {
    position: 'relative',
    '& input': {
      width: '100%',
      padding: '18px 52px 18px 20px',
      background: '#F3F3F3',
      borderRadius: '8px',
      border: '1px solid #F3F3F3',
      color: 'var(--gray-)',
      font: 'var(--body)',
      '&:focus': {
        borderColor: 'var(--gray--)'
      }
    }
  },
  buttonWrapper: {
    position: 'absolute',
    right: '0',
    top: '0',
    height: '100%',
    width: '60px'
  },
  button: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    color: 'var(--gray)',
    '& *': {
      pointerEvents: 'none'
    },
    '&:focus': {
      color: 'var(--dark-blue)'
    },
    '&:hover': {
      color: 'var(--dark-blue)'
    }
  },
  successIcon: {
    color: 'var(--gray) !important'
  },
  restricted: {
    color: 'transparent !important',
    textShadow: '0 0 7px rgb(0 0 0 / 50%)',
    userSelect: 'none !important'
  },
  restrictedCopy: {
    position: 'absolute',
    top: '-5px',
    right: '-3px',
    background: '#333',
    outline: '4px solid #333',
    borderRadius: '100%',
    width: '10px !important',
    height: '10px'
  }
})(({ classes, link, onCopy }) => {
  const [success, setSuccess] = useState(false)
  const { hasAccessToTL } = useSubscriptionDetails()
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)

  return (
    <div className={classes.container}>
      <label className={classes.label}>Share link</label>
      <div className={classes.link}>
        <input
          type="text"
          value={!hasAccessToTL ? 'Unlock Pobble Premium' : link}
          readOnly
          className={!hasAccessToTL ? classes.restricted : ''}
        />
        <Tooltip
          className={classes.buttonWrapper}
          placement="bottom"
          content={!success ? 'Copy' : 'Copied'}>
          <ButtonElement
            onClick={() => {
              if (!hasAccessToTL) {
                return setUpsellModalOpen(true)
              }
              onCopy && onCopy()
              navigator.clipboard.writeText(link).then(
                () => {
                  setSuccess(true)
                },
                () => {
                  toast.error(
                    'Something went wrong. Try to copy the link manually'
                  )
                }
              )
            }}
            className={classNames(
              classes.button,
              'metrics__copy-student-link'
            )}>
            {!success && <FontAwesomeIcon icon={faCopy} />}
            {success && (
              <FontAwesomeIcon className={classes.successIcon} icon={faCheck} />
            )}
            {!hasAccessToTL && (
              <SubsCrown accent className={classes.restrictedCopy} />
            )}
          </ButtonElement>
        </Tooltip>
      </div>
      <UpsellModal
        id="edit-lesson"
        isOpen={upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </div>
  )
})

const ShareButton = injectSheet({
  button: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    textAlign: 'center',
    color: 'var(--gray)',
    '& *': {
      pointerEvents: 'none'
    },
    '&:hover $icon': {
      background: '#e0e0e0',
      borderColor: '#e0e0e0'
    },
    '&:focus $icon': {
      borderColor: 'var(--gray)'
    },
    '&:active $icon': {
      borderColor: 'var(--gray--)'
    }
  },
  icon: {
    border: '1px solid #F2F2F2',
    width: '70px',
    height: '70px',
    background: '#F2F2F2',
    borderRadius: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    position: 'relative',
    '& svg:nth-child(2)': {
      position: 'absolute',
      top: '4px',
      right: '2px',
      borderRadius: '100%',
      width: '10px',
      height: '10px',
      outline: '4px solid #333',
      background: '#333'
    }
  },
  title: {
    font: 'var(--body--)',
    fontWeight: 'bold'
  }
})(({ classes, icon, children, onClick, className }) => {
  return (
    <ButtonElement
      onClick={onClick}
      className={classNames(classes.button, className)}>
      <span className={classes.icon}>{icon}</span>
      <span className={classes.title}>{children}</span>
    </ButtonElement>
  )
})

const Share = injectSheet({
  container: {
    padding: '24px'
  },
  title: {
    margin: '0 0 32px',
    font: 'var(--heading_)',
    color: 'var(--gray)'
  },
  buttons: {
    margin: '0',
    listStyle: 'none',
    padding: '0',
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap'
  },
  pageLinkSection: {
    marginTop: '32px'
  },
  editLessonSection: {
    borderTop: '1px solid #D4D4D4',
    paddingTop: '24px',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '32px'
  },
  gclassroomIcon: {
    width: '32px'
  }
})(
  ({
    classes,
    presentation,
    onAction,
    onPrint,
    onEmail,
    onQrCode,
    onSendToStudents,
    userIsOwner,
    from
  }) => {
    const { present } = usePresentMode()
    const { me } = useMe()
    const [token, setToken] = useState(presentation.token)
    const { hasAccessToTL } = useSubscriptionDetails()
    const {
      handleWritingPackClick,
      writingPackState,
      closeWritingPackModal
    } = useWritingPack({
      presentation
    })

    const posthogActionData = {
      id: presentation.id,
      title: presentation.title,
      category: presentation.category,
      from,
      hasAccessToTL,
      role: me.account.role_in_life
    }

    const link = !token
      ? null
      : `${window.location.origin}/lessons/preview/${token}`

    /**
     * If presentation is private, automatically set it to public
     * to be able to get a public link
     */
    useEffect(
      () => {
        if (!presentation.token) {
          apiClient
            .put(`/v3/presentations/${presentation.id}/set_to_public`, null, {
              params: { include: 'presentation.details' }
            })
            .then(res => setToken(res.data.presentation.token))
        }
      },
      [presentation]
    )

    const [upsellModalOpen, setUpsellModalOpen] = useState(false)

    return (
      <div className={classes.container}>
        <h2 className={classes.title}>Share</h2>
        <ul className={classes.buttons}>
          <li>
            <ShareButton
              className="metrics__present_mode_trigger"
              onClick={() => {
                onAction()
                apiClient.post('/v3/me/activated_with_product', {
                  type: 'feature'
                })
                posthog.capture('activate', { type: 'feature' })
                posthog.capture('Share action', {
                  action: 'Full screen',
                  ...posthogActionData
                })
                apiClient.post(
                  `/v3/presentations/${presentation.id}/presented_fullscreen`
                )
                present(presentation.id)
              }}
              icon={<FontAwesomeIcon icon={faExpand} />}>
              Full screen
            </ShareButton>
          </li>
          <li>
            <ShareButton
              className="metrics__google-classroom"
              onClick={() => {
                if (!hasAccessToTL) {
                  return setUpsellModalOpen(true)
                }
                onAction()
                apiClient.post('/v3/me/activated_with_product', {
                  type: 'feature'
                })
                posthog.capture('activate', { type: 'feature' })
                posthog.capture('Share action', {
                  action: 'Google Classroom',
                  ...posthogActionData
                })
                window.open(
                  `https://classroom.google.com/u/0/share?url=${
                    window.location.origin
                  }/lessons/preview/${token}&${objectToQueryParam({
                    title: `Pobble Lesson - "${presentation.title}"`,
                    body: `Write a story about "${presentation.title}"`
                  })}`
                )
              }}
              icon={
                <>
                  <img
                    className={classes.gclassroomIcon}
                    src={gclassroom}
                    alt="Google Classroom"
                  />
                  {!hasAccessToTL && <SubsCrown accent />}
                </>
              }>
              Google <br />Classroom
            </ShareButton>
          </li>
          <li>
            <ShareButton
              className="metrics__print"
              onClick={() => {
                if (!hasAccessToTL) {
                  return setUpsellModalOpen(true)
                }
                onAction()
                apiClient.post('/v3/me/activated_with_product', {
                  type: 'feature'
                })
                posthog.capture('activate', { type: 'feature' })
                posthog.capture('Share action', {
                  action: 'Print',
                  ...posthogActionData
                })
                onPrint()
              }}
              icon={
                <>
                  <FontAwesomeIcon icon={faPrint} />
                  {!hasAccessToTL && <SubsCrown accent />}
                </>
              }>
              Print / PDF
            </ShareButton>
            <WritingPackModal />
          </li>
          {presentation.p365 && (
            <li>
              <ShareButton
                onClick={() => {
                  if (!hasAccessToTL) {
                    return setUpsellModalOpen(true)
                  }
                  handleWritingPackClick()
                  apiClient.post('/v3/me/activated_with_product', {
                    type: 'feature'
                  })
                  posthog.capture('activate', { type: 'feature' })
                  posthog.capture('Share action', {
                    action: 'Writing pack',
                    ...posthogActionData
                  })
                }}
                icon={
                  <>
                    <FontAwesomeIcon icon={faFileAlt} />
                    {!hasAccessToTL && <SubsCrown accent />}
                  </>
                }>
                Writing pack
              </ShareButton>
              <WritingPackModal
                {...writingPackState}
                requestClose={closeWritingPackModal}
              />
            </li>
          )}
          <li>
            <ShareButton
              className="metrics__qr-code"
              onClick={() => {
                if (!hasAccessToTL) {
                  return setUpsellModalOpen(true)
                }
                onAction()
                apiClient.post('/v3/me/activated_with_product', {
                  type: 'feature'
                })
                posthog.capture('activate', { type: 'feature' })
                posthog.capture('Share action', {
                  action: 'QR Code',
                  ...posthogActionData
                })
                onQrCode(link)
              }}
              icon={
                <>
                  <FontAwesomeIcon icon={faQrcode} />
                  {!hasAccessToTL && <SubsCrown accent />}
                </>
              }>
              QR Code
            </ShareButton>
          </li>
          {userIsOwner &&
            !!me.account.policy.can_see_actions && (
              <>
                <li>
                  <ShareButton
                    className="metrics__share-email"
                    onClick={() => {
                      onAction()
                      apiClient.post('/v3/me/activated_with_product', {
                        type: 'feature'
                      })
                      posthog.capture('activate', { type: 'feature' })
                      posthog.capture('Share action', {
                        action: 'Email',
                        ...posthogActionData
                      })
                      onEmail()
                    }}
                    icon={<FontAwesomeIcon icon={faEnvelope} />}>
                    Email <br />teacher
                  </ShareButton>
                </li>
                <li>
                  <ShareButton
                    className="metrics__share-students-session"
                    onClick={() => {
                      onAction()
                      apiClient.post('/v3/me/activated_with_product', {
                        type: 'feature'
                      })
                      posthog.capture('activate', { type: 'feature' })
                      posthog.capture('Share action', {
                        action: 'Students',
                        ...posthogActionData
                      })
                      onSendToStudents()
                    }}
                    icon={<FontAwesomeIcon icon={faUsersClass} />}>
                    My students
                  </ShareButton>
                </li>
              </>
            )}
        </ul>
        <div className={classes.pageLinkSection}>
          <LessonLink
            link={link}
            onCopy={() => {
              apiClient.post('/v3/me/activated_with_product', {
                type: 'feature'
              })
              posthog.capture('activate', { type: 'feature' })
              posthog.capture('Share action', {
                action: 'Copy link',
                ...posthogActionData
              })
            }}
          />
        </div>
        {!userIsOwner && (
          <div className={classes.editLessonSection}>
            <EditLesson
              presentation={presentation}
              onClick={() => {
                posthog.capture('Share action', {
                  action: 'Edit lesson',
                  ...posthogActionData
                })
              }}
            />
          </div>
        )}
        <UpsellModal
          id="edit-lesson"
          isOpen={upsellModalOpen}
          requestClose={() => setUpsellModalOpen(false)}
        />
      </div>
    )
  }
)

export const ShareModal = injectSheet({
  content: {
    padding: '0'
  }
})(({ classes, isOpen, presentation, requestClose, userIsOwner, from }) => {
  const [printModalOpen, setPrintModalOpen] = useState(false)
  const [sendToStudentsOpen, setSendToStudentsOpen] = useState(false)
  const [shareModalOpen, setShareModalOpen] = useState(false)
  const [qrModal, setQrModal] = useState({ open: false, link: null })
  const { me } = useMe()

  return (
    <>
      <Modal closeButton isOpen={isOpen} requestClose={requestClose}>
        <ModalContent className={classes.content}>
          <Share
            from={from}
            userIsOwner={userIsOwner}
            presentation={presentation}
            onAction={requestClose}
            onPrint={() => setPrintModalOpen(true)}
            onEmail={() => setShareModalOpen(true)}
            onQrCode={link => setQrModal({ open: true, link })}
            onSendToStudents={() => setSendToStudentsOpen(true)}
            onSendToPupils={() => setSendToStudentsOpen(true)}
          />
        </ModalContent>
      </Modal>
      {presentation && (
        <>
          <PrintModal
            id={presentation.id}
            isOpen={printModalOpen}
            requestClose={() => setPrintModalOpen(false)}
          />
          <ShareLessonModal
            id={presentation.id}
            title={presentation.title}
            isOpen={shareModalOpen}
            disableEmailClassification={!me.account.policy.can_see_actions}
            requestClose={() => setShareModalOpen(false)}
          />
          <QRCodeModal
            requestClose={() => setQrModal({ ...qrModal, open: false })}
            link={qrModal.link}
            isOpen={qrModal.open}
          />
          <SendToPupilsModal
            presentationId={presentation.id}
            presentationTitle={presentation.title}
            presentationLo={presentation.slides[1].text}
            isOpen={sendToStudentsOpen}
            requestClose={() => setSendToStudentsOpen(false)}
          />
        </>
      )}
    </>
  )
})
